import { useGlobal } from "@/app/providers/use-global";
import { Button } from "@/components/ui/button";
import { useScreen } from "@/hooks/use-screen";
import type { PromptAndResponse } from "@/hooks/use-send-message";
import { Maximize2, Minimize2 } from "lucide-react";
import { type Dispatch, type SetStateAction, memo } from "react";
import StatsPopup from "./stats-popup";

export type StatsBoxProps = {
  chat: PromptAndResponse[];
  handleClearChat: () => void;
  isResponseExtended: boolean | null;
  setIsResponseExtended: Dispatch<SetStateAction<boolean>>;
};

const StatsBox = memo(
  ({
    chat,
    handleClearChat,
    isResponseExtended,
    setIsResponseExtended,
  }: StatsBoxProps) => {
    const { isMobile } = useScreen();

    const { isIframe, isFullScreenIframe } = useGlobal();
    return (
      <>
        {chat.length > 0 && (
          <div className="flex w-full py-2 md:py-0 pl-5 pr-4 justify-between bg-background z-10 h-10">
            <div className="flex gap-6">
              <Button
                variant={"link"}
                onClick={handleClearChat}
                // TODO: Check with design to include the color into the theme
                className="p-0 text-muted-foreground dark:text-[#BCBCBC] hover:text-primaryaccent dark:hover:text-primaryaccent hover:no-underline"
              >
                Clear chat
              </Button>
              {!isMobile && (isIframe ? isFullScreenIframe : true) && (
                <Button
                  className="w-min cursor-pointer h-auto p-2 hover:bg-transparent"
                  variant={"ghost"}
                  onClick={() => setIsResponseExtended((prev) => !prev)}
                >
                  {isResponseExtended ? (
                    <div className="hover:text-primaryaccent text-muted-foreground flex flex-row gap-2">
                      <Minimize2 size={20} className="rotate-45" />
                      Fit
                    </div>
                  ) : (
                    <div className="hover:text-primaryaccent text-muted-foreground flex flex-row gap-2">
                      <Maximize2 size={20} className="rotate-45" />
                      Expand Width
                    </div>
                  )}
                </Button>
              )}
            </div>
            <StatsPopup chat={chat} />
          </div>
        )}
      </>
    );
  },
);

StatsBox.displayName = "StatsBox";

export default StatsBox;
